import { Component } from '@angular/core';
import { GlobalService } from 'src/app/services/helper/global-helper';

@Component({
  selector: 'app-visualizations-list',
  templateUrl: './visualizations-list.component.html',
  styleUrls: ['./visualizations-list.component.scss']
})
export class VisualizationsListComponent {

  public machinenumber: string = "";
  imgExist: boolean = true;

  constructor(private global: GlobalService){
    this.global.machineNumber.subscribe({
      next: newValue => {this.machinenumber = newValue.number;}
    });
  }

  updateImg() {
    this.imgExist = false;
  }

}
